// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__TM4JV","column":"style_column__khceC"};